<template>
    <el-container direction="vertical" class="spreadsheet">
        <el-row type="flex" align="middle" class="spreadsheet-header" justify="space-between">
            <el-col :span="13">
                <div class="spreadsheet-header-title">
                    {{ title }}
                </div>
                <div class="qualification-tabs mt5" v-if="headerOptions.isFilterVisible">
                    <el-radio-group v-model="statusTab" size="mini" @change="onStatusTabChange">
                        <el-radio-button label="active">
                            Активные
                        </el-radio-button>
                        <el-radio-button label="closed">
                            Закрытые
                        </el-radio-button>
                        <el-radio-button label="missed">
                            Неотвеченные звонки
                        </el-radio-button>
                        <el-radio-button label="all">
                            Все
                        </el-radio-button>
                    </el-radio-group>
                </div>
                <div class="spreadsheet-header-filter-info" v-if="headerOptions.isFilterVisible">
                    <span class="spreadsheet-header-filter-info_black">
                        Поиск по:
                    </span>
                    <span class="spreadsheet-header-filter-info_gray">
                        {{ filterTitle }}
                    </span>
                </div>
            </el-col>
            <el-col :span="2" justify="end" v-if="headerOptions.isUnreadMessagesCountVisible">
                <div class="flex-row-2col">
                    <div class="flex-column wrap-envelop"></div>
                    <div class="flex-column wrap-unread-msg">
                        {{ unreadCount }}
                    </div>
                </div>
            </el-col>
            <el-col :span="2" v-if="headerOptions.isFilterVisible">
                <el-popover
                    popper-class="grid-search-dialog"
                    placement="top"
                    width="293"
                    trigger="click"
                    v-model="isFilterFormVisible"
                >
                    <el-button slot="reference" class="spreadsheet-header-button" type="warning">
                        поиск
                    </el-button>
                    <el-form label-position="top" @keyup.enter.native="filterApplied">
                        <el-form-item :label="fieldsNames.id" :label-width="formLabelWidth" v-if="isColumnVisible('id')">
                            <el-input v-model="filterModel.id" autocomplete="off" size="mini" clearable />
                        </el-form-item>
                        <el-form-item :label="fieldsNames.status" :label-width="formLabelWidth" v-if="isColumnVisible('status.name')">
                            <el-select
                                v-model="filterModel.status"
                                :placeholder="fieldsNames.status"
                                size="mini"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                multiple
                                collapse-tags
                                clearable
                            >
                                <el-option
                                    v-for="item in statusOptions"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                />
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="fieldsNames.officeName" :label-width="formLabelWidth" v-if="isColumnVisible('office.name')">
                            <el-select
                                v-model="filterModel.officeName"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                filterable
                                multiple
                                collapse-tags
                                clearable
                                autocomplete
                                :placeholder="fieldsNames.officeName"
                                size="mini"
                            >
                                <el-option v-for="item in officeList" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="fieldsNames.responsibleUser" :label-width="formLabelWidth" v-if="isColumnVisible('status.name')">
                            <el-select
                                v-model="filterModel.responsibleUser"
                                :placeholder="fieldsNames.responsibleUser"
                                size="mini"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                multiple
                                autocomplete
                                filterable
                                collapse-tags
                                clearable
                            >
                                <el-option
                                    v-for="item in employers"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                />
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="fieldsNames.created_at" :label-width="formLabelWidth" v-if="isColumnVisible('created_at')">
                            <el-date-picker
                                v-model="filterModel.created_at"
                                type="daterange"
                                range-separator="по"
                                start-placeholder="дата"
                                end-placeholder="дата"
                                clearable
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                size="mini"
                                class="w100"
                                :picker-options="pickerOptions"
                            />
                        </el-form-item>
                        <el-form-item :label="fieldsNames.contactName" :label-width="formLabelWidth" v-if="isColumnVisible('contact.name')">
                            <el-input v-model="filterModel.contactName" autocomplete="off" size="mini" clearable />
                        </el-form-item>
                        <el-form-item :label="fieldsNames.contactPhone" :label-width="formLabelWidth" v-if="isColumnVisible('contact.phone')">
                            <el-input v-model="filterModel.contactPhone" autocomplete="off" size="mini" clearable />
                        </el-form-item>
                        <el-form-item :label="fieldsNames.contactEmail" :label-width="formLabelWidth" v-if="isColumnVisible('contact.email')">
                            <el-input v-model="filterModel.contactEmail" autocomplete="off" size="mini" clearable />
                        </el-form-item>
                        <el-form-item :label="fieldsNames.address" :label-width="formLabelWidth" v-if="isColumnVisible('address')">
                            <el-input v-model="filterModel.address" autocomplete="off" size="mini" clearable />
                        </el-form-item>
                        <el-form-item :label="fieldsNames.title" :label-width="formLabelWidth" v-if="isColumnVisible('title')">
                            <el-input v-model="filterModel.title" autocomplete="off" size="mini" clearable />
                        </el-form-item>
                        <el-form-item :label="fieldsNames.link" :label-width="formLabelWidth" v-if="isColumnVisible('link.name')">
                            <el-select
                                v-model="filterModel.link"
                                :placeholder="fieldsNames.link"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                multiple
                                collapse-tags
                                clearable
                                size="mini"
                            >
                                <el-option
                                    v-for="item in linkOptions"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                />
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="fieldsNames.custom_fields" :label-width="formLabelWidth" v-if="isColumnVisible('custom_fields')">
                            <el-input v-model="filterModel.customFields" autocomplete="off" size="mini" clearable />
                        </el-form-item>
                        <el-form-item class="wrap-filter-checkbox" :label-width="formLabelWidth" v-if="isColumnVisible('unread_messages')">
                            <el-checkbox v-model="filterModel.unread">
                                {{ fieldsNames.unread }}
                            </el-checkbox>
                        </el-form-item>
                    </el-form>
                    <div class="popover-footer">
                        <el-button @click="hideFilterForm">
                            Отменить
                        </el-button>
                        <el-button type="warning" @click="filterApplied">
                            Применить
                        </el-button>
                    </div>
                </el-popover>
            </el-col>
            <el-col :span="3">
                <span class="spreadsheet-header-total">
                    Всего записей: {{ pagesInfo.total }}
                </span>
            </el-col>
            <el-col :span="3" v-if="headerOptions.isNewButtonVisible">
                <el-button class="spreadsheet-header-button" type="warning" @click="goNewCard">
                    новая квалификация
                </el-button>
            </el-col>
            <el-col :span="3" v-if="headerOptions.isGoBackButtonVisible">
                <el-button class="spreadsheet-header-button" type="warning" @click="goBack">
                    Назад
                </el-button>
            </el-col>
            <el-col :span="1" title="Excel" class="icon-excel" v-if="isExcelButtonVisible">
                <div class="spreadsheet-header-excel" @click="handleExcelAction()">
                    &nbsp;
                </div>
            </el-col>
        </el-row>
        <el-row type="flex" align="top" class="spreadsheet-table" v-loading="loading">
            <el-col :span="24">
                <ag-grid-vue
                    class="ag-theme-balham spreadsheet-table-grid"
                    :grid-options="gridOptions"
                    :column-defs="columnDefs"
                    :framework-components="frameworkComponents"
                />
            </el-col>
        </el-row>
        <el-row type="flex" align="bottom" class="spreadsheet-bar">
            <el-col :span="6">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="pagesInfo.total"
                    :page-size="pageModel.pageSize"
                    :current-page="pageModel.currentPage"
                    :small="true"
                    @current-change="getCurrentPage"
                />
            </el-col>
            <el-col :span="10">
                <div class="spreadsheet-bar-pages">
                    <span class="spreadsheet-bar-pages-title">
                        Выводить по:
                    </span>
                    <span
                        class="spreadsheet-bar-pages-size"
                        :class="{'is-active': isSetPageSize20}"
                        @click="setPageSize(20)"
                    >
                        20
                    </span>
                    <span
                        class="spreadsheet-bar-pages-size"
                        :class="{'is-active': isSetPageSize50}"
                        @click="setPageSize(50)"
                    >
                        50
                    </span>
                    <span
                        class="spreadsheet-bar-pages-size"
                        :class="{'is-active': isSetPageSize100}"
                        @click="setPageSize(100)"
                    >
                        100
                    </span>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="spreadsheet-bar-total">
                    <span>
                        Строк выведено: {{ totalRows }} Из них выделено: {{ selectedRowsCount }}
                    </span>
                </div>
            </el-col>
        </el-row>
    </el-container>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue';
import TableHeaderSettings from '@/components/TableHeaderSettings';
import TableHeaderMessages from '@/components/TableHeaderMessages';
import LeadTarget from '@/components/gridComponents/LeadTarget';
import { pickerOptions } from '@/common/pickerOptions';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import capitalize from 'lodash/capitalize';
import '@/assets/styles/list.scss';
import { viewCustomFields, formatEmployerNameHtml } from '@/common/utilities';
import localReferences from '@/helpers/localReferences';
import { eventBus } from '@/common/eventBus';
import DealGridHeader from '../deals/GridHeader.vue';
import FileSaver from 'file-saver';
import moment from 'moment';

library.add(faEye);

const LS = localReferences.leadStatuses;

export default {
    name: 'LeadsGrid',
    data() {
        return {
            title: 'Квалификация',
            statusTab: 'active',
            isFilterFormVisible: false,
            headerOptions: {
                isUnreadMessagesCountVisible: true,
                isFilterVisible: true,
                isNewButtonVisible: true,
                isGoBackButtonVisible: false,
                isExcelButtonVisible: false
            },
            filterModel: {
                created_at: [],
                unread: null,
                status: [...LS.activeIds],
                show_closed: false,
                responsibleUser: [],
                contactName: null,
                contactPhone: null,
                contactEmail: null,
                officeName: [],
                link: [],
                address: null,
                title: null,
                custom_fields: null
            },
            fieldsNames: {
                id: 'id',
                created_at: 'Дата',
                unread: 'Есть непрочитанное сообщение',
                status: 'Статус',
                officeName: 'Офис',
                responsibleUser: 'Ответственный',
                contactName: 'Имя контакта',
                contactPhone: 'Телефон контакта',
                contactEmail: 'E-mail контакта',
                link: 'Канал связи',
                address: 'Адрес',
                title: 'Название',
                custom_fields: 'Дополнительные поля'
            },
            pageModel: {
                currentPage: 1,
                pageSize: 20
            },
            formLabelWidth: '120px',
            totalRows: 0,
            selectedRowsCount: 0,
            loading: true,
            pickerOptions,
            gridOptions: {
                rowSelection: 'multiple',
                suppressDragLeaveHidesColumns: false,
                suppressPaginationPanel: true,
                suppressLoadingOverlay: true,
                rowDeselection: true,
                enableCellTextSelection: true,
                headerHeight: 50,
                rowHeight: 40,
                domLayout: 'autoHeight',
                onRowDataChanged: this.onRowDataChanged.bind(this),
                onRowSelected: this.onRowSelected.bind(this),
                onColumnResized: this.onColumnResized.bind(this),
                onDisplayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this),
                onRowDoubleClicked: this.onSelectionChanged.bind(this),
                onSortChanged: this.onSortChanged.bind(this),
                defaultColDef: {
                    sortable: true,
                    filter: false,
                    resizable: true,
                    cellClass: 'column-text',
                    comparator: () => {
                        return 0;
                    }
                }
            },
            columnDefs: [],
            employerOptions: [],
            statusNew: LS.statusNew,
            statusTarget: LS.statusTarget,
            statusNotTarget: LS.statusNotTarget,
            frameworkComponents: null
        };
    },
    components: {
        'ag-grid-vue': AgGridVue
    },
    computed: {
        leads() {
            return this.$store.state.leads.leads;
        },
        unreadCount() {
            return this.$store.state.leads.unreadCount;
        },
        pagesInfo() {
            return this.$store.state.leads.pages;
        },
        employers() {
            return this.$store.state.references.employers;
        },
        setting() {
            return this.$store.state.preferences.setting;
        },
        statusOptions() {
            return this.$store.state.references.leadStatuses;
        },
        linkOptions() {
            return this.$store.state.references.leadLinks;
        },
        isSetPageSize20() {
            return this.pageModel.pageSize === 20;
        },
        isSetPageSize50() {
            return this.pageModel.pageSize === 50;
        },
        isSetPageSize100() {
            return this.pageModel.pageSize === 100;
        },
        filterTitle() {
            let result = '';
            for (const field in this.filterModel) {
                if (!Object.prototype.hasOwnProperty.call(this.filterModel, field) || !this.filterModel[field]) {
                    continue;
                }
                //служебные флаги таба — не в «Поиск по»
                if (field === 'show_closed') {
                    continue;
                }
                const getNamesFrom = (obj) => {
                    if (!obj || !obj.length) {
                        return '';
                    }
                    const names = this.filterModel[field]
                        .map(id => {
                            const found = obj.find(item => +item.id === +id);
                            return found ? found.name : null;
                        })
                        .filter(Boolean);
                    return names.length
                        ? (this.fieldsNames[field] + ': ' + names.join(' | ') + '; ')
                        : '';
                };
                if (['string', 'object'].includes(typeof this.filterModel[field]) && this.filterModel[field].length) {
                    switch (field) {
                        case 'status':
                            //таб «Активные» / «Закрытые» — не дублируем список id в шапке
                            if (this.statusTab === 'active' || this.statusTab === 'closed') {
                                break;
                            }
                            result += getNamesFrom(this.statusOptions);
                            break;
                        case 'link':
                            //таб «Неотвеченные звонки» — не дублируем
                            if (this.statusTab === 'missed') {
                                break;
                            }
                            result += getNamesFrom(this.linkOptions);
                            break;
                        case 'officeName':
                        case 'office_id':
                            result += getNamesFrom(this.officeList);
                            break;
                        case 'created_at':
                            result += this.fieldsNames[field] + ': ' +
                                'с ' + this.filterModel[field][0] +
                                ' по ' + this.filterModel[field][1] + '; ';
                            break;
                        default:
                            result += (this.fieldsNames[field] + ': ' + this.filterModel[field] + '; ');
                    }
                }
                if (field === 'unread') {
                    result += this.fieldsNames[field] + '; ';
                }
            }
            return result;
        },
        officeList() {
            return this.$store.state.references.offices;
        },
        isExcelButtonVisible() {
            //использовать в задаче реализации экспорта в excel
            return true && this.$store.getters.isCanLeadExportExcel;
        }
    },
    created() {
        this.frameworkComponents = {
            leadTarget: LeadTarget
        };
        this.columnDefs = [
            {
                headerName: this.capitalize(this.fieldsNames.id),
                field: 'id',
                cellRenderer: (params) => {
                    return this.getLinkElement(params.data.id, params.data.id, this.getRouteForCard(params.data), 'a', 'spreadsheet-table-id-link');
                }
            },
            {
                headerName: this.capitalize(this.fieldsNames.unread),
                field: 'unread_messages',
                cellRenderer: (params) => {
                    let response = '';
                    if (params.data.unread_messages > 0) {
                        response = `<div class="flex-row-2col">
                                <div class="flex-column envelop"></div>
                                <div class="flex-column unread-msg">${params.data.unread_messages}</div>
                             </div>`;
                    }
                    return response;
                },
                headerComponentFramework: TableHeaderMessages,
                cellClass: null,
                width: 50
            },
            {
                headerName: this.capitalize(this.fieldsNames.created_at),
                field: 'created_at'
            },
            {
                headerName: this.fieldsNames.status,
                field: 'status.name',
                cellRenderer: ({ data }) => data.status ? `<div class="text-center lead-status-${data.status_id}">${data.status.name}</div>` : ''
            },
            {
                headerName: this.capitalize(this.fieldsNames.title),
                field: 'title',
                cellRenderer: (params) => {
                    const missed = +(params.data.link_id) === localReferences.referenceLink.link_missed_call;
                    const icon = missed
                        ? '<span class="call-missed-icon" title="Пропущенный звонок"></span>'
                        : '';
                    return icon + (params.data.title || '');
                }
            },
            {
                headerName: this.capitalize(this.fieldsNames.officeName),
                field: 'office.name'
            },
            {
                headerName: this.capitalize(this.fieldsNames.responsibleUser),
                field: 'responsible_user.full_name',
                cellRenderer: (params) => {
                    if (+params.data.responsible_user_id > 0) {
                        return formatEmployerNameHtml(params.data.responsible_user);
                    }
                    return null;
                }
            },
            {
                headerName: this.capitalize(this.fieldsNames.contactName),
                field: 'contact.name'
            },
            {
                headerName: this.capitalize(this.fieldsNames.contactPhone),
                field: 'contact.phone',
                cellRenderer: (params) => {
                    if (params.data.contact && params.data.contact.contact_phones) {
                        return params.data.contact.contact_phones.reduce((result, item) => result + item.phone + '; ', '').slice(0, -2);
                    }
                    return '';
                }
            },
            {
                headerName: this.capitalize(this.fieldsNames.contactEmail),
                field: 'contact.email'
            },
            {
                headerName: this.capitalize(this.fieldsNames.address),
                field: 'address'
            },
            {
                headerName: this.capitalize(this.fieldsNames.link),
                field: 'link.name'
            },
            {
                headerName: '',
                field: 'value',
                cellRenderer: 'leadTarget',
                width: 200
            },
            {
                headerName: this.capitalize(this.fieldsNames.custom_fields),
                field: 'custom_fields',
                width: 220,
                cellRenderer: ({ data }) => data.custom_fields ? viewCustomFields(data.custom_fields) : ''
            },
            {
                headerName: '',
                field: '',
                headerComponentFramework: TableHeaderSettings,
                cellRenderer: (params) => {
                    return this.getLinkElement(params.data.id, '', { name: 'lead-card', params: { id: params.data.id } }, 'div', 'cell-icon');
                },
                width: 40,
                cellClass: null
            }
        ];
    },
    watch: {
        leads: {
            deep: true,
            handler(newLeads) {
                if (!this.gridOptions || !this.gridOptions.api) return;
                //skip duplicate setRowData after server refresh (setLeads triggers watch)
                if (this._applyingServerRows) return;
                this.gridOptions.api.setRowData(newLeads);
            }
        }
    },
    mounted() {
        this.loadSettings();
        eventBus.$on('leads:list-changed', this.onLeadsListChanged);
        this._onLeadsSoftReload = () => {
            if (!this.loading) {
                this.getDataFromServer();
            }
        };
        this.$root.$on('leads:soft-reload', this._onLeadsSoftReload);
    },
    beforeDestroy() {
        eventBus.$off('leads:list-changed', this.onLeadsListChanged);
        if (this._leadsRefreshTimer) {
            clearTimeout(this._leadsRefreshTimer);
        }
        if (this._onLeadsSoftReload) {
            this.$root.$off('leads:soft-reload', this._onLeadsSoftReload);
        }
    },
    methods: {
        onLeadsListChanged() {
            if (this._leadsRefreshTimer) {
                clearTimeout(this._leadsRefreshTimer);
            }
            //debounce: begin+answer+hangup → one GET with current filter/page
            this._leadsRefreshTimer = setTimeout(() => {
                this.refreshListFromServer();
            }, 600);
        },
        //server truth without loading overlay; keep scroll + selection
        refreshListFromServer() {
            if (!this.gridOptions || !this.gridOptions.api) {
                return;
            }
            const api = this.gridOptions.api;
            const firstRow = typeof api.getFirstDisplayedRow === 'function'
                ? api.getFirstDisplayedRow()
                : 0;
            const selectedIds = (api.getSelectedRows() || []).map(r => +r.id);

            const requestParams = {
                size: this.pageModel.pageSize,
                page: this.pageModel.currentPage,
                sort: api.getSortModel(),
                filter: this.filterModel
            };
            //before dispatch: setLeads triggers deep-watch — avoid double setRowData
            this._applyingServerRows = true;
            this.$store.dispatch('leads/getPaginatedList', requestParams).then(
                response => {
                    if (!this.gridOptions || !this.gridOptions.api) {
                        this._applyingServerRows = false;
                        return;
                    }
                    const gridApi = this.gridOptions.api;
                    gridApi.setRowData(this.leads);
                    this._applyingServerRows = false;

                    this.pageModel.pageSize = +response.data.meta.per_page;
                    this.pageModel.currentPage = response.data.meta.current_page;

                    const count = gridApi.getDisplayedRowCount();
                    if (count > 0 && firstRow >= 0) {
                        const idx = Math.min(firstRow, count - 1);
                        if (typeof gridApi.ensureIndexVisible === 'function') {
                            gridApi.ensureIndexVisible(idx, 'top');
                        }
                    }
                    if (selectedIds.length && typeof gridApi.forEachNode === 'function') {
                        gridApi.forEachNode(node => {
                            if (node.data && selectedIds.indexOf(+node.data.id) !== -1) {
                                node.setSelected(true);
                            }
                        });
                    }
                }
            ).catch(() => {
                this._applyingServerRows = false;
            });
        },
        loadSettings() {
            this.$store.dispatch('preferences/getPreferences').then(
                () => {
                    this.setSettings();
                    this.getDataFromServer();
                }).catch(() => {
                this.applyStatusTab('active');
                this.getDataFromServer();
            });
        },
        setSettings() {
            if (this.setting.leads) {
                if (this.setting.leads.table && this.gridOptions.columnApi) {
                    this.gridOptions.columnApi.setColumnState(this.setting.leads.table);
                }
                //не дергаем onSortChanged здесь — загрузка через getDataFromServer
                if (this.setting.leads.sort && this.gridOptions.api) {
                    this.gridOptions.api.setSortModel(this.setting.leads.sort);
                }
                if (this.setting.leads.filter) {
                    this.filterModel = Object.assign({}, this.filterModel, JSON.parse(JSON.stringify(this.setting.leads.filter)));
                }
                if (this.setting.leads.page) {
                    this.pageModel = JSON.parse(JSON.stringify(this.setting.leads.page));
                }
                this.resetContactFilter();
                this.syncStatusTabFromFilter();
            } else {
                this.applyStatusTab('active');
            }
        },
        //таб ↔ filter.status / show_closed / link
        applyStatusTab(tab) {
            this.statusTab = tab;
            if (tab === 'active') {
                this.filterModel.status = [...LS.activeIds];
                this.filterModel.show_closed = false;
                this.filterModel.link = [];
            } else if (tab === 'closed') {
                this.filterModel.status = [...LS.finalIds];
                this.filterModel.show_closed = true;
                this.filterModel.link = [];
            } else if (tab === 'missed') {
                this.filterModel.status = [LS.statusNew, LS.statusWaitingReply];
                this.filterModel.link = [localReferences.referenceLink.link_missed_call];
                this.filterModel.show_closed = true;
            } else {
                this.filterModel.status = [];
                this.filterModel.show_closed = true;
                this.filterModel.link = [];
            }
        },
        onStatusTabChange(tab) {
            this.applyStatusTab(tab);
            this.pageModel.currentPage = 1;
            this.getDataFromServer();
        },
        syncStatusTabFromFilter() {
            const st = this.filterModel.status || [];
            const lk = this.filterModel.link || [];
            const sorted = [...st].sort((a, b) => a - b).join(',');
            const activeKey = [...LS.activeIds].sort((a, b) => a - b).join(',');
            const finalKey = [...LS.finalIds].sort((a, b) => a - b).join(',');

            //missed tab: link=[8] + status=[1] + show_closed
            if (sorted === '1,8' && this.filterModel.show_closed &&
                lk.length === 1 && lk[0] === localReferences.referenceLink.link_missed_call
            ) {
                this.statusTab = 'missed';
                return;
            }

            if (!st.length && this.filterModel.show_closed) {
                this.statusTab = 'all';
            } else if (sorted === finalKey) {
                this.statusTab = 'closed';
            } else if (sorted === activeKey || !st.length) {
                this.statusTab = 'active';
                if (!st.length) {
                    this.filterModel.status = [...LS.activeIds];
                }
            } else {
                this.statusTab = 'all';
            }
        },
        resetContactFilter() {
            this.filterModel.contactName = null;
            this.filterModel.contactEmail = null;
            this.filterModel.contactPhone = null;
        },
        hideFilterForm() {
            this.isFilterFormVisible = false;
        },
        getLinkElement(id, name, route, elementType, className) {
            const element = document.createElement(elementType);
            if (elementType === 'a') {
                element.href = this.$router.resolve(route).href;
            }
            element.innerText = name;
            element.className += ' ' + className;
            element.addEventListener('click', e => {
                e.preventDefault();
                this.$router.push(route);
            });
            return element;
        },
        getRouteForCard(lead) {
            if (lead.deal && lead.deal.id) {
                return { name: 'deal-card', params: { id: '' + lead.deal.id } };
            }
            return { name: 'lead-card', params: { id: '' + lead.id } };
        },
        onSelectionChanged(e) {
            this.$router.push(this.getRouteForCard(e.node.data));
        },
        getDataFromServer() {
            if (!this.gridOptions.api) {
                this.loading = false;
                return;
            }
            const requestParams = {
                size: this.pageModel.pageSize,
                page: this.pageModel.currentPage,
                sort: this.gridOptions.api.getSortModel(),
                filter: this.filterModel
            };
            this.loading = true;
            this.$store.dispatch('leads/getPaginatedList', requestParams).then(
                response => {
                    this.gridOptions.api.setRowData(this.leads || []);
                    if (response.data && response.data.meta) {
                        this.pageModel.pageSize = +response.data.meta.per_page;
                        this.pageModel.currentPage = response.data.meta.current_page;
                    }
                    this.saveSetting();
                }).catch(
                error => {
                    console.log(error);
                }).finally(() => {
                this.loading = false;
            });
        },
        setPageSize(size) {
            this.pageModel.pageSize = size;
            this.getDataFromServer();
        },
        goNewCard() {
            this.$router.push({ name: 'lead-card-new' });
        },
        getCurrentPage(page) {
            this.pageModel.currentPage = page;
            this.getDataFromServer();
        },
        filterApplied() {
            this.isFilterFormVisible = false;
            this.pageModel.currentPage = 1;
            this.getDataFromServer();
        },
        onRowDataChanged() {
            this.totalRows = this.gridOptions.api.getDisplayedRowCount();
        },
        onRowSelected() {
            this.selectedRowsCount = this.gridOptions.api.getSelectedRows().length;
        },
        isColumnVisible(colId) {
            return this.isFilterFormVisible && this.gridOptions.columnApi ? this.gridOptions.columnApi.getColumn(colId).visible : false;
        },
        onDisplayedColumnsChanged() {
            this.saveSetting();
        },
        onColumnResized(data) {
            if (data.finished && data.source === 'uiColumnDragged') {
                this.saveSetting();
            }
        },
        onSortChanged() {
            //после mount setSortModel не должен гонять второй loadSettings-цикл:
            //загрузка идёт из loadSettings/getDataFromServer; sort-change — только от UI
            if (this.loading) {
                return;
            }
            this.getDataFromServer();
        },
        async saveSetting() {
            const data = {
                'leads': {
                    'table': this.gridOptions.columnApi.getColumnState(),
                    'sort': this.gridOptions.api.getSortModel(),
                    'filter': this.filterModel,
                    'page': this.pageModel
                }
            };
            await this.$store.dispatch('preferences/setPreferences', data);
        },
        goBack() {
            this.$router.go(-1);
        },
        exportLeads() {
            const requestParams = {
                sort: this.gridOptions.api.getSortModel(),
                filter: this.filterModel,
                filename: `Квалификация_${this.pagesInfo.total}_(${moment().format('DD.MM.YY_HHmmss')}).xlsx`
            };
            this.loading = true;
            this.$store.dispatch('leads/getLeadsExportedToExcel', requestParams).then(response => {
                FileSaver(new Blob([response.data], { type: 'application/vnd.ms-excel' }), requestParams.filename);
            }).catch(error => {
                console.log(error);
            }).finally(() => {
                this.loading = false;
            });
        },
        handleExcelAction() {
            if (+this.pagesInfo.total > 15000) {
                this.$message({
                    showClose: true,
                    message: 'Можно выгрузить не более 15 000 лидов',
                    type: 'error',
                    duration: 5000,
                    customClass: this.alertClass()
                });
            } else {
                this.exportLeads();
            }
        },
        capitalize: capitalize
    }
};
</script>
